import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

export interface TagFormData {
  labelEncoding: string;
  type: string;
  description: string;
  status: boolean;
  isInheritable: boolean;
  isPageVisible: boolean;
}

@Component({
  selector: 'app-tag-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    ToggleSwitchModule,
  ],
  templateUrl: './tag-dialog.html',
  styleUrl: './tag-dialog.css',
})
export class TagDialogComponent {
  private dialogRef = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);

  isEdit = signal(false);
  showErrors = signal(false);

  typeOptions = [
    { label: 'API Tags', value: 'API Tags' },
    { label: 'Menu Label', value: 'Menu Label' },
    { label: 'Button Label', value: 'Button Label' },
    { label: 'Status Label', value: 'Status Label' },
    { label: 'Form Label', value: 'Form Label' },
  ];

  formData: TagFormData = {
    labelEncoding: '',
    type: '',
    description: '',
    status: true,
    isInheritable: false,
    isPageVisible: true,
  };

  constructor() {
    // Check if editing existing tag
    if (this.config?.data?.tag) {
      this.isEdit.set(true);
      const tag = this.config.data.tag;
      this.formData = {
        labelEncoding: tag.labelEncoding || '',
        type: tag.type || '',
        description: tag.describe || '',
        status: tag.status !== undefined ? tag.status : true,
        isInheritable: tag.isInheritable || false,
        isPageVisible:
          tag.isPageVisible !== undefined ? tag.isPageVisible : true,
      };
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onTypeChange(value: string): void {
    this.formData.type = value;
  }

  onConfirm(): void {
    // Validate required fields
    if (!this.formData.labelEncoding || !this.formData.type) {
      this.showErrors.set(true);
      return;
    }

    // Return the form data
    this.dialogRef.close(this.formData);
  }
}
